import React from 'react';

import Auth from 'j-toker'
import Raven from 'raven-js'
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker, { unregister } from './registerServiceWorker';

import { apiUrl, baseUrl } from './app/_CONSTANTS'

Raven.config('https://c1944ffa76914de4ae533cad74e2c305@sentry.io/1263677').install();
Auth.configure({
  apiUrl: apiUrl,
  authProviderPaths: {
    facebook:  '/auth/facebook'
  },
  passwordResetSuccessUrl: function() {
    return `${baseUrl}/account/reset-password`;
  },
}).always(function() {
  ReactDOM.render(<App />, document.getElementById('app'));
  // registerServiceWorker();
  unregister();
});



// WEBPACK FOOTER //
// ./src/index.js